import { useState, useEffect } from "react"
import { EstadoCivilKeys, IEstadoCivil } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { estadoCivilKeyToLabel } from "../../../detalhes-do-projeto/filtros/estado-civil"
// Icon
import { useUIService } from "../../../../../../../use-cases/ui"
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteEstadoCivil = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Use State
    const [selectedEstadoCivil, setSelectedEstadoCivil] = useState<IEstadoCivil[]>([])

    // Hook
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const estadosCivisSelecionados = createRecorteExtracaoForm.fields.Filtros?.estadoCivil || [];

        if (estadosCivisSelecionados.length > 0) {
            setSelectedEstadoCivil(estadosCivisSelecionados);
        } else {
            setSelectedEstadoCivil([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.estadoCivil]);

    // Filtra as opções para remover os itens já selecionados
    const filteredEstadosCivis = EstadoCivilKeys.filter((estadoCivil: IEstadoCivil) =>
        !selectedEstadoCivil.some((selected: IEstadoCivil) => selected === estadoCivil)
    );

    const handleEstadoCivilSelectionChange = (value: IEstadoCivil[]) => {
        setSelectedEstadoCivil(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'estadoCivil',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'estadoCivil',
                formType: 'create'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredEstadosCivis}
                    getOptionLabel={(option) => estadoCivilKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    value={selectedEstadoCivil}
                    onChange={(event, value) => {
                        handleEstadoCivilSelectionChange(value);
                    }}
                    noOptionsText='Nenhum estado civil encontrado'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de tipos de estado civil"
                        />
                    )}
                />
            </Grid>
        </>
    )
}